/* SelectionBar — floating hairline pill anchored bottom-right (Phase 6).
   Shown only while at least one photo is favorited and the gallery isn't
   yet delivered. Replaces the older full-width sticky bar with a refined
   couture-grade composition: cream-on-charcoal translucent, hairline gold
   border, serif italic count left, gold uppercase REVIEW SELECTIONS link
   right. On mobile it stretches centered along the bottom edge. */

export default function SelectionBar({
  favCount,
  includedEdits,
  extraCount,
  extraTotal,
  maxSel,
  onOpenSubmit,
  view = "all",
  onViewChange,
  isUpdate = false,
}) {
  if (!favCount) return null;
  const exceedsMax = maxSel > 0 && favCount > maxSel;
  const total = maxSel > 0 ? maxSel : null;

  return (
    <div
      className="fixed z-30 inset-x-4 bottom-6 sm:inset-x-auto sm:right-6 sm:bottom-8 sm:max-w-md"
      data-testid="selection-bar"
    >
      <div
        className="flex items-center justify-between gap-4 px-5 sm:px-6 py-3 sm:py-3.5 backdrop-blur-md border"
        style={{
          background: "rgba(14, 13, 12, 0.86)",
          color: "#FAF9F6",
          borderColor: "rgba(201, 169, 97, 0.45)",
        }}
      >
        <div className="flex flex-col leading-tight min-w-0">
          <span
            className="text-base sm:text-lg italic tabular-nums"
            style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
          >
            <strong className="font-medium not-italic mr-1">{favCount}</strong>
            {total ? <span className="opacity-60"> / {total}</span> : null}
            <span className="opacity-80 ml-2">selected</span>
          </span>
          {includedEdits > 0 && extraCount > 0 && (
            <span className="text-[10px] uppercase tracking-[0.28em] text-[#C9A961] mt-0.5">
              {extraCount} extra · +${extraTotal.toFixed(2)}
            </span>
          )}
          {onViewChange && (
            <button
              onClick={() => onViewChange(view === "selected" ? "all" : "selected")}
              className="mt-1 self-start text-[10px] uppercase tracking-[0.24em] text-stone-400 hover:text-[#FAF9F6] underline underline-offset-4 decoration-stone-600 transition-colors"
              data-testid="toggle-selected-view-btn"
            >
              {view === "selected" ? "← Show all photos" : "View selected only"}
            </button>
          )}
        </div>
        <button
          onClick={onOpenSubmit}
          disabled={exceedsMax}
          className="shrink-0 text-[10px] uppercase tracking-[0.32em] font-medium text-[#C9A961] hover:text-[#FAF9F6] disabled:opacity-40 transition-colors"
          data-testid="open-submit-btn"
        >
          {isUpdate ? "Update selections →" : "Review selections →"}
        </button>
      </div>
    </div>
  );
}
